import { DownloadIcon } from "lucide-react";
import { Button } from "../ui/button";
import { downloadClientFile } from "@/service/weexpertService";
import { getDecodedFileName } from '@/lib/utils';

export const FileComponent = (props) => {
  const { files, clinetId } = props;

  const file = files.map((item, index) => (
    <div key={index} className="w-full flex justify-between pb-2">
      <div className="flex justify-center items-center">
        {getDecodedFileName(item.file.path)}
      </div>
      <Button className="bg-inherit hover:bg-inherit" onClick={() => {
        downloadClientFile(clinetId, item.file.id)
      }}>
        <DownloadIcon className="text-blue-600" />
      </Button>
    </div>
  ))

  return (
    <div>
      {file}
    </div>
  )
}
